<app-loading-indicator [isLoading]="isLoading"></app-loading-indicator>

@if (!isLoading) {
  <div class="projectable-form-wrapper">
    <lib-form-header
      [data]="{}"
      [title]="'Potential Conflicts'"
      [showHeaderToggle]="false"
      [showHeaderButton]="false"
      (actionRequested)="headerActionRequested($event)"
    ></lib-form-header>
    <div class="projectable-form-container identity-conflict-details-container">
      <app-ui-conflict-details [data]="pageData" variant="identity"></app-ui-conflict-details>
    </div>
  </div>
}
